
import { Component, Vue, Prop } from 'vue-property-decorator';
import CardReintegro from './CardReintegro.vue';
import { Reintegro } from '@/models';

@Component({
  components: { 
      CardReintegro
    }
})
export default class ReintegriCards extends Vue {
    @Prop() private reintegri!: Reintegro[];
    @Prop({ default: false }) private compact!: boolean;
}
